import Core from '@mediaplatform/basketball-sdk';
import { useMemo } from 'react';
import {
  basketball,
  basketballCompetition,
  basketballPlayoff,
  basketballStage,
  basketballStageList,
  basketballTeamProgramme,
  basketballTournamentProgramme,
} from '../api';
import initSmpBasketballSDK from '../lib/SmpBasketballSDK';

import { BasketballSDKOptions as basketballOptions } from '../types';

export const getBasketballApi = (sdkBasketball: Core) => {
  return {
    $basketball: basketball(sdkBasketball),
    $stage: basketballStage(sdkBasketball),
    $stageList: basketballStageList(sdkBasketball),
    $competition: basketballCompetition(sdkBasketball),
    $playoff: basketballPlayoff(sdkBasketball),
    $tournamentProgramme: basketballTournamentProgramme(sdkBasketball),
    $teamProgramme: basketballTeamProgramme(sdkBasketball),
  };
};

// Plain function to use outside React components
export const initBasketballApi = (sdkOptions: basketballOptions) => {
  const sdkBasketball = initSmpBasketballSDK(sdkOptions);

  return getBasketballApi(sdkBasketball);
};

// React hook to use inside React components
export default function useBasketballApi(sdkOptions: basketballOptions) {
  const sdkBasketball = useMemo(() => initSmpBasketballSDK(sdkOptions), [sdkOptions]);

  return useMemo(() => getBasketballApi(sdkBasketball), [sdkBasketball]);
}
